import { toLower } from "./utils.js";
const valueFilter = (ast, context) => {
  const needle = toLower(ast.value);
  ast.filter = (v) => {
    const text = context.textFn(v) || "";
    return text.indexOf(needle) >= 0;
  };
};
export {
  valueFilter
};
//# sourceMappingURL=value-filter.js.map
